import type { ReactNode } from 'react'
import { useCan, type PermRequirement } from '@/shared/permissions'

/**
 * Renders its children only when the logged-in admin holds the permission.
 *
 *   <Can perm="DELETE /admin/package/*"><Button>Delete</Button></Can>
 *   <Can perm={['POST /admin/user/*', 'POST /admin/auth/register']} fallback={<span>Read only</span>}>…</Can>
 */
export function Can({ perm, children, fallback = null }: { perm: PermRequirement; children: ReactNode; fallback?: ReactNode }) {
  const can = useCan()
  return <>{can(perm) ? children : fallback}</>
}
